import styled, { css } from 'styled-components';

const calculateSizes = (props) => {
  const { vertical, width, height } = props;
  if (vertical) {
    return css`
      width: ${width ? `${width}px` : `auto`};
      height: ${height ? `${height}px` : `100%`};
    `;
  }
  return css`
    width: ${width ? `${width}px` : `100%`};
    height: ${height ? `${height}px` : `auto`};
  `;
};
const ThumbnailCarouselStyled = styled.div`
  display: flex;
  flex-direction: ${(props) => props.vertical ? `column` : `row`};
  justify-content: center;
  align-items: center;

  .ThumbnailCarousel {
    &__slider {
      display: flex;
      overflow: scroll;
      flex-direction: ${(props) => props.vertical ? `column` : `row`};
      ${calculateSizes}
      scroll-snap-type: both mandatory;
      gap: ${(props) => `${props.gap}px`};
      -ms-overflow-style: none;
      scrollbar-width: none;
      align-items: center;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__action {
      display: flex;
      justify-content: center;
      align-items: center;

      &--90 {
        transform: rotate(90deg);
      }

      &--180 {
        transform: rotate(180deg);
      }

      &--270 {
        transform: rotate(270deg);
      }
    }

    &__slider-item {
      height: ${(props) => `${props.itemHeight}px`};
      width: ${(props) => `${props.itemWidth}px`};
      scroll-snap-align: start;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export { ThumbnailCarouselStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
